import script from "./FloatingTopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingTopNav.vue?vue&type=script&setup=true&lang=js"

import "./FloatingTopNav.vue?vue&type=style&index=0&id=c1341660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1341660"]])

export default __exports__